import { Box, Tabs as MuiTabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(() => ({
  overflow: 'auto',
  pr: '5px',
}));

export const Title = styled(Typography)(() => ({
  marginBottom: '5px',
  color: 'rgba(1, 128, 148, 1)',
  fontWeight: 700,
}));

export const Tabs = styled(MuiTabs)(() => ({
  minHeight: 'unset',

  '.MuiTabs-flexContainer': {
    flexWrap: 'wrap',
    gap: '10px',
  },

  '.MuiTab-root': {
    padding: '5px 10px 6px',
    minHeight: 'unset',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '21px',
    borderRadius: '6px',
    textTransform: 'none',
    border: '1px solid rgba(221, 221, 234, 1)',
    color: 'rgba(34, 40, 34, 1)',
  },

  '.Mui-selected': {
    background: 'rgba(201, 255, 235, 1)',
    border: 'none',
  },
}));

export const TabContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  marginTop: '15px',
  marginRight: '5px',

  '.MuiInputBase-multiline': {
    padding: '15px',

    textarea: {
      minHeight: '61px',
      padding: 0,
    },
  },

  '.MuiOutlinedInput-input': {
    padding: '14px 15px 15px',
  },

  fieldset: {
    top: 0,
  },

  [theme.breakpoints.down('lg')]: {
    '.MuiInputBase-multiline': {
      textarea: {
        minHeight: '194px',
      },
    },
  },

  [theme.breakpoints.down('md')]: {
    '.MuiInputBase-multiline': {
      textarea: {
        minHeight: '39px',
      },
    },
  },

  [theme.breakpoints.down('sm')]: {
    '.MuiInputBase-multiline': {
      textarea: {
        minHeight: '194px',
      },
    },
  },
}));

export const InputsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '15px 20px',

  '> *': {
    flex: '1 1 0',
  },

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const RadioButtonsContainer = styled(InputsContainer)(({ theme }) => ({
  gap: '20px',

  '.MuiFormControlLabel-root .MuiRadio-root': {
    width: '40px',
    height: '40px',

    '+ .MuiFormControlLabel-label': {
      marginLeft: '0',
    },
  },

  [theme.breakpoints.down('lg')]: {
    marginTop: '5px',
  },

  [theme.breakpoints.down('md')]: {
    rowGap: '15px',
    marginTop: '0',
  },

  [theme.breakpoints.down('sm')]: {
    rowGap: '20px',
    marginTop: '5px',
  },
}));

export const RadioButtonLabel = styled(Box)(() => ({
  '.MuiTypography-body1': {
    fontSize: '18px',
    lineHeight: '23.4px',
    fontWeight: 700,
  },

  '.MuiTypography-body2': {
    color: 'rgba(159, 159, 159, 1)',
  },
}));

export const LoaderContainer = styled(Box)(() => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
